import React, { useCallback, useEffect, useState } from 'react';
import { questionAPI } from '../../../api';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const XLSX = require('xlsx');

const AdminSubjects: React.FC = () => {
  const [subjects, setSubjects] = useState<any[]>([]);
  const [form, setForm] = useState({
    name: '', category: '',
    pilgi_enabled: true, silgi_enabled: true,
    is_active: true, order: 0,
  });
  const [uploading, setUploading] = useState(false);
  const [uploadResult, setUploadResult] = useState<string>('');

  const load = useCallback(() => {
    questionAPI.adminSubjects().then(res => setSubjects(res.data));
  }, []);

  useEffect(() => { load(); }, [load]);

  // 종목 추가
  const create = async () => {
    if (!form.name.trim()) { alert('종목명을 입력해주세요.'); return; }
    try {
      await questionAPI.createSubject(form);
      setForm({ name: '', category: '', pilgi_enabled: true, silgi_enabled: true, is_active: true, order: 0 });
      load();
    } catch (e) { alert('등록 실패'); }
  };

  // 활성/비활성 토글
  const toggle = async (id: number, is_active: boolean) => {
    try { await questionAPI.updateSubject(id, { is_active: !is_active }); load(); } catch (e) {}
  };

  // 필기/실기 토글
  const toggleExam = async (id: number, field: 'pilgi_enabled' | 'silgi_enabled', val: boolean) => {
    try { await questionAPI.updateSubject(id, { [field]: !val }); load(); } catch (e) {}
  };

  // 삭제
  const del = async (id: number) => {
    if (!window.confirm('삭제하시겠습니까? 연결된 문제도 모두 삭제됩니다.')) return;
    try { await questionAPI.deleteSubject(id); load(); } catch (e) {}
  };

  // 엑셀 업로드 (종목 엑셀)
  // 엑셀 형식: A=과목명, B=카테고리, C=필기ON(1/0), D=실기ON(1/0), E=활성(1/0), F=순서
  const handleExcelUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    setUploadResult('');

    try {
      const ab = await file.arrayBuffer();
      const wb = XLSX.read(ab, { type: 'array' });
      const ws = wb.Sheets[wb.SheetNames[0]];
      const rows: any[][] = XLSX.utils.sheet_to_json(ws, { header: 1 });

      if (rows.length < 2) { alert('데이터가 없습니다.'); setUploading(false); return; }

      let added = 0, skipped = 0;
      for (let i = 1; i < rows.length; i++) {
        const row = rows[i];
        if (!row || !row[0]) continue;
        const name = String(row[0]).trim();
        const category = row[1] ? String(row[1]).trim() : '';
        const pilgi_enabled = row[2] === undefined || Number(row[2]) !== 0;
        const silgi_enabled = row[3] === undefined || Number(row[3]) !== 0;
        const is_active = row[4] === undefined || Number(row[4]) !== 0;
        const order = row[5] ? Number(row[5]) : i;

        // 이미 있으면 스킵
        const exists = subjects.find(s => s.name === name);
        if (exists) { skipped++; continue; }

        try {
          await questionAPI.createSubject({ name, category, pilgi_enabled, silgi_enabled, is_active, order });
          added++;
        } catch (e) { skipped++; }
      }
      setUploadResult(`✅ ${added}개 추가 완료${skipped > 0 ? ` (${skipped}개 중복/오류 스킵)` : ''}`);
      load();
    } catch (err) {
      setUploadResult('❌ 엑셀 읽기 실패');
    }
    setUploading(false);
    e.target.value = '';
  };

  // 카테고리별 그룹
  const mainSubjects = subjects.filter(s => !s.category);
  const categoryMap: Record<string, any[]> = {};
  subjects.filter(s => s.category).forEach(s => {
    if (!categoryMap[s.category]) categoryMap[s.category] = [];
    categoryMap[s.category].push(s);
  });

  const SubjectCard = ({ s }: { s: any }) => (
    <div style={{
      padding: '10px 12px',
      borderRadius: 8,
      background: s.is_active ? 'white' : '#f8fafc',
      border: `1px solid ${s.is_active ? 'var(--border)' : '#e2e8f0'}`,
      opacity: s.is_active ? 1 : 0.6,
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 6 }}>
        <div>
          <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--text-primary)' }}>{s.name}</div>
          {s.category && <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 2 }}>{s.category}</div>}
        </div>
        <button className="btn btn-danger btn-sm" style={{ padding: '2px 8px' }} onClick={() => del(s.id)}>✕</button>
      </div>

      {/* 필기/실기 토글 */}
      <div style={{ display: 'flex', gap: 4, marginBottom: 6 }}>
        <button
          className="btn btn-sm"
          style={{ fontSize: 11, padding: '2px 8px', background: s.pilgi_enabled ? '#dbeafe' : '#f1f5f9', color: s.pilgi_enabled ? '#1d4ed8' : '#94a3b8', border: 'none' }}
          onClick={() => toggleExam(s.id, 'pilgi_enabled', s.pilgi_enabled)}
        >📝 필기 {s.pilgi_enabled ? 'ON' : 'OFF'}</button>
        <button
          className="btn btn-sm"
          style={{ fontSize: 11, padding: '2px 8px', background: s.silgi_enabled ? '#fef3c7' : '#f1f5f9', color: s.silgi_enabled ? '#b45309' : '#94a3b8', border: 'none' }}
          onClick={() => toggleExam(s.id, 'silgi_enabled', s.silgi_enabled)}
        >🔧 실기 {s.silgi_enabled ? 'ON' : 'OFF'}</button>
      </div>

      {/* 활성/비활성 */}
      <button
        className="btn btn-sm"
        style={{ width: '100%', fontSize: 11, background: s.is_active ? '#dcfce7' : '#fee2e2', color: s.is_active ? '#15803d' : '#dc2626', border: 'none' }}
        onClick={() => toggle(s.id, s.is_active)}
      >{s.is_active ? '✅ 활성' : '❌ 비활성'}</button>
    </div>
  );

  return (
    <div className="admin-page">
      <div className="admin-page-header">
        <div className="admin-page-title"><span className="icon">📚</span>종목 관리</div>
        <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>전체 {subjects.length}개</div>
      </div>

      {/* 종목 직접 추가 */}
      <div className="card" style={{ marginBottom: 16 }}>
        <div className="card-header">➕ 종목 직접 추가</div>
        <div className="card-body">
          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center' }}>
            <input
              className="form-control" style={{ flex: 2, minWidth: 160 }}
              placeholder="종목명 (예: 전기기사)"
              value={form.name}
              onChange={e => setForm({...form, name: e.target.value})}
              onKeyDown={e => e.key === 'Enter' && create()}
            />
            <input
              className="form-control" style={{ flex: 1, minWidth: 120 }}
              placeholder="카테고리 (없으면 주요과목)"
              value={form.category}
              onChange={e => setForm({...form, category: e.target.value})}
            />
            <input
              type="number"
              className="form-control" style={{ width: 80 }}
              placeholder="순서"
              value={form.order}
              onChange={e => setForm({...form, order: +e.target.value})}
            />
            <label style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 13, whiteSpace: 'nowrap' }}>
              <input type="checkbox" checked={form.pilgi_enabled} onChange={e => setForm({...form, pilgi_enabled: e.target.checked})} />
              필기
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 13, whiteSpace: 'nowrap' }}>
              <input type="checkbox" checked={form.silgi_enabled} onChange={e => setForm({...form, silgi_enabled: e.target.checked})} />
              실기
            </label>
            <button className="btn btn-primary" onClick={create}>추가</button>
          </div>
        </div>
      </div>

      {/* 엑셀 업로드 */}
      <div className="card" style={{ marginBottom: 20 }}>
        <div className="card-header">📂 엑셀로 일괄 추가</div>
        <div className="card-body">
          <p style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 12 }}>
            엑셀 형식: <strong>A=종목명 | B=카테고리 | C=필기ON(1/0) | D=실기ON(1/0) | E=활성(1/0) | F=순서</strong>
            <br />※ 1행은 헤더, 2행부터 데이터 / 이미 등록된 종목은 스킵
          </p>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <label className="btn btn-primary" style={{ cursor: 'pointer', margin: 0 }}>
              {uploading ? '업로드 중...' : '📂 엑셀 파일 선택'}
              <input
                type="file" accept=".xlsx,.xls"
                style={{ display: 'none' }}
                onChange={handleExcelUpload}
                disabled={uploading}
              />
            </label>
            {uploadResult && (
              <span style={{ fontSize: 13, fontWeight: 600, color: uploadResult.startsWith('✅') ? 'var(--success)' : 'var(--danger)' }}>
                {uploadResult}
              </span>
            )}
          </div>
        </div>
      </div>

      {/* 주요 과목 */}
      {mainSubjects.length > 0 && (
        <div className="card" style={{ marginBottom: 16 }}>
          <div className="card-header">⭐ 주요 과목 ({mainSubjects.length}개)</div>
          <div className="card-body">
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: 8 }}>
              {mainSubjects.map(s => <SubjectCard key={s.id} s={s} />)}
            </div>
          </div>
        </div>
      )}

      {/* 카테고리별 */}
      {Object.keys(categoryMap).map(cat => (
        <div className="card" key={cat} style={{ marginBottom: 16 }}>
          <div className="card-header">📁 {cat} ({categoryMap[cat].length}개)</div>
          <div className="card-body">
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: 8 }}>
              {categoryMap[cat].map(s => <SubjectCard key={s.id} s={s} />)}
            </div>
          </div>
        </div>
      ))}

      {subjects.length === 0 && (
        <div className="empty-state">
          <div className="icon">📭</div>
          <p>등록된 종목이 없습니다.</p>
        </div>
      )}
    </div>
  );
};

export default AdminSubjects;
